import { apiRequest } from "@/api";

const state = {
  NotificationPush: true,
  //send email state
  Send_by_email_select: undefined,
  Send_by_email_select_elements: [],
  //---------//

  add_to_cart_emty: false,
  purchase_emty: false,
  loading: false,
  filter_panel_open: [],
  all_messages: [],
  messages: [],
  store_conversation_length: 0,
  current_message_length: 0,
  messages_length: 0,
  new_msg: false,
  last_page: 1,
  api_msg_pull: 0,
  pull_call: false,
  filter_rest: [],
  sorts: {
    selected_sort: "",
    sent_at: {
      between: { start: null, end: null },
      order: false,
      dec_order: false,
    },
    waiting: {
      between: { start: null, end: null },
      order: false,
      dec_order: false,
    },
    online: { order: false, dec_order: false },
    priority: { order: false, dec_order: false },
    add_to_cart: { order: false, dec_order: false },
    purchase: { order: false, dec_order: false },
    status: { filter_by: [], sort: false },
    status_email: { filter_by: [], sort: false },
    conversation: { data: [], filter_by: ["show_all"] },
  },
  status: [
    { color: "red darken-1", value: "To answer" },
    { color: "error darken-1", value: "To check" },
    { color: "error darken-1", value: "To check sto" },
    { color: "error darken-1", value: "To check Tech" },
    { color: "green darken-2", value: "By email" },
    { color: "#65ff00", value: "Answered - Pend" },
    { color: "#65ff00", value: "Answered" },
    { color: "#008000", value: "Solved" },
    { color: "#008000", value: "Solved (Email)" },
  ],
  email_status: [
    { color: "grey", value: "none" },
    { color: "red darken-1", value: "To answer" },
    { color: "warning", value: "Transferred - CS" },
    { color: "warning", value: "Transferred - Sto" },
    { color: "warning", value: "Transferred - Tech" },
    { color: "warning", value: "To notify (restock)" },
    { color: "#65ff00", value: "Answered - Pend" },
    { color: "#65ff00", value: "Answered" },
    { color: "#008000", value: "Answered_Relancé" },
    { color: "#008000", value: "Purchase" },
  ],
};

const mutations = {
  SET_MSG: (state, data) => {
    state.store_conversation_length = parseFloat(data.convearsation_length);
    if (!state.pull_call) state.pull_call = true;
    if (data.page == 0) state.all_messages = data.msg;
    else {
      for (let i = 0; i < data.msg.length; i++) {
        const element = data.msg[i];
        state.all_messages.push(element);
      }
    }
    state.current_message_length = state.all_messages.length;
    //console.log('here :',state.sorts.selected_sort,state.sorts,state.sorts.conversation.filter_by);
    state.filter_rest = state.all_messages;
    if (state.sorts.selected_sort) {
      data.dispatch("filter_date", state.sorts.selected_sort);
      data.dispatch("filter_bools", state.sorts.selected_sort);
      data.dispatch("filter_status", state.sorts.selected_sort);
    }
    if (state.sorts.conversation.filter_by === "show_conversations")
      data.dispatch("filter_conversation", state.sorts.conversation.filter_by);
  },
  SET_MESSAGES: (state, data) => {
    state.messages_length = data.length;
    state.messages = data;
  },
  UPDATE_MESSAGES_AGNET: (state, item) => {
    state.all_messages = state.all_messages.map((message) => {
      if (message.agent === item) message.agent = "";
      return message;
    });
  },
};

const getContext = async (type, contexts) => {
  if (contexts[type]) {
    if (type == 0) {
      return "all";
    } else {
      return contexts[type].mode;
    }
  }
  return undefined;
};

// add the status looks in Messages-dash
function status_filter(st) {
  if (st.status === "Solved") {
    st.statusObj = { color: "#008000", value: "Solved" };
  } else if (st.status === "Solved (Email)") {
    st.statusObj = { color: "#008000", value: "Solved (Email)" };
  } else if (st.status === "To check") {
    st.statusObj = { color: "error darken-1", value: "To check" };
  } else if (st.status === "To check sto") {
    st.statusObj = { color: "error darken-1", value: "To check sto" };
  } else if (st.status === "By email") {
    st.statusObj = { color: "green darken-2", value: "By email" };
  } else if (st.status === "Answered") {
    st.statusObj = { color: "#65ff00", value: "Answered" };
  } else if (st.status === "To answer") {
    st.statusObj = { color: "red darken-1", value: "To answer" };
  } else if (st.status === "To check Tech") {
    st.statusObj = { color: "error darken-1", value: "To check Tech" };
  } else if (st.status === "Answered - Pend") {
    st.statusObj = { color: "#65ff00", value: "Answered - Pend" };
  } else {
    if (st.sender_type === "admin" || st.sender_type === "bot") {
      st.statusObj = { color: "#65ff00", value: "Answered" };
    } else st.statusObj = { color: "red darken-1", value: "To answer" };
  }
}

function Email_status_filter(st) {
  if (st.email_status === "Answered") {
    st.EmailStatusObj = { color: "#65ff00", value: "Answered" };
  } else if (st.email_status === "Transferred - CS") {
    st.EmailStatusObj = { color: "warning", value: "Transferred - CS" };
  } else if (st.email_status === "Transferred - Tech") {
    st.EmailStatusObj = { color: "warning", value: "Transferred - Tech" };
  } else if (st.email_status === "To notify (restock)") {
    st.EmailStatusObj = { color: "warning", value: "To notify (restock)" };
  } else if (st.email_status === "Answered - Pend") {
    st.EmailStatusObj = { color: "#65ff00", value: "Answered - Pend" };
  } else if (st.email_status === "Transferred - Sto") {
    st.EmailStatusObj = { color: "warning", value: "Transferred - Sto" };
  } else if (st.email_status === "Answered_Relancé") {
    st.EmailStatusObj = { color: "#008000", value: "Answered_Relancé" };
  } else if (st.email_status === "To answer") {
    st.EmailStatusObj = { color: "red darken-1", value: "To answer" };
  } else if (st.email_status === "Purchase") {
    st.EmailStatusObj = { color: "#008000", value: "Purchase" };
  } else st.EmailStatusObj = { color: "grey", value: "none" };
}

function SetAddToCart(element, rootState) {
  const elem = rootState.productAdded.find(
    (ele) => ele.user_id == element.guid
  );
  if (elem) {
    element.add_to_cart = {
      count: elem.all_products_added_to_cart.split(",").length,
      selected_product: [],
    };
    let tmp2 = [];
    let tmp3 = [];
    tmp2 = elem.all_products_added_to_cart.split(",");
    tmp3 = elem.product_date.split(",");
    for (let a = 0; a < tmp2.length; a++) {
      element.add_to_cart.selected_product.push({
        url: tmp2[a],
        date: tmp3[a],
      });
    }
  } else {
    element.add_to_cart = {
      count: 0,
    };
  }
}

function SetPruchase(element, rootState) {
  const elem = rootState.productPurchase.find(
    (ele) => ele.user_id == element.guid
  );
  if (elem) {
    element.pruchase = {
      count: elem.all_products_added_to_cart.split(",").length,
      selected_product: [],
    };
    let tmp2 = [];
    let tmp3 = [];
    tmp2 = elem.all_products_added_to_cart.split(",");
    tmp3 = elem.product_date.split(",");
    for (let a = 0; a < tmp2.length; a++) {
      element.pruchase.selected_product.push({
        url: tmp2[a],
        date: tmp3[a],
      });
    }
  } else {
    element.pruchase = {
      count: 0,
    };
  }
}

// add last message filtring if it is look message
function last_message(item) {
  if (item.content[0] == "{" && item.content[item.content.length - 1] == "}") {
    if (
      Object.keys(JSON.parse(item.content)).includes("carousel") &&
      JSON.parse(item.content).carousel
    )
      item.last_message = { key: "Carousel" };
    else if (
      Object.keys(JSON.parse(item.content)).includes("attachment") &&
      JSON.parse(item.content).attachment
    )
      item.last_message = { key: "Attachment" };
    else if (
      Object.keys(JSON.parse(item.content)).includes("look") &&
      JSON.parse(item.content).look
    )
      item.last_message = { key: "Look" };
    else if (
      Object.keys(JSON.parse(item.content)).includes("form") &&
      JSON.parse(item.content).form
    )
      item.last_message = `From ${
        JSON.parse(item.content).message
          ? JSON.parse(item.content).message.split(".")[0]
          : ""
      }`;
    else if (
      Object.keys(JSON.parse(item.content)).includes("buttons") &&
      JSON.parse(item.content).buttons &&
      !item.content.includes("message_pt2") &&
      !item.content.includes("norm_pt2")
    )
      item.last_message = `${
        JSON.parse(item.content).message
          ? JSON.parse(item.content).message.split(".")[0]
          : ""
      } Selection`;
    else if (
      Object.keys(JSON.parse(item.content)).includes("grid") &&
      JSON.parse(item.content).grid
    )
      item.last_message = { key: "Grid" };
    else if (
      Object.keys(JSON.parse(item.content)).includes("brands") &&
      JSON.parse(item.content).brands
    )
      item.last_message = { key: "Brands" };
    else item.last_message = JSON.parse(item.content).message;
  } else {
    //condition noted by adrien  (can you change "chat.not_here" to "Box_message_email" )
    if (item.content === "chat.not_here") {
      item.content = "[Box Email & Message]";
    }
    item.last_message = item.content;
  }
}

function waiting_calc(item) {
  const d = (new Date(item.sent_at) + "").split(" ");
  const tmp = [d[2], d[1], d[3], d[4]].join(" ");
  const b = new Date();
  const a = new Date(tmp);
  let diff = Math.abs(a - b);
  const ms = diff % 1000;
  diff = (diff - ms) / 1000;
  const ss = diff % 60;
  diff = (diff - ss) / 60;
  const mm = diff % 60;
  diff = (diff - mm) / 60;
  const hh = diff % 24;
  const days = (diff - hh) / 24;
  item.waiting_value = `${days ? `${days}d` : ""} ${hh ? `${hh}h` : ""} ${
    mm ? `${mm}m` : ""
  }`;
}

function date_form(element) {
  const d = (new Date(element.sent_at) + "").split(" ");
  const tmp = [d[2], d[1], d[3], d[4]].join(" ");
  const res = tmp.split(":");
  element.sent_at_value = `${res[0]}:${res[1]}`;
}

const actions = {
  filter_date({ state, dispatch }, column) {
    console.log("action filter", column);
    if (column === "sent_at") {
      if (
        state.sorts[column].between.end &&
        state.sorts[column].between.start
      ) {
        //console.log("between sent_at", column, state.sorts[column].between);
        const ed = new Date(state.sorts[column].between.end);
        const sd = new Date(state.sorts[column].between.start);
        if (ed < sd) return { error: true };
        state.filter_rest = state.all_messages.filter((d) => {
          var time = new Date(d.sent_at);
          return sd <= time && time <= ed;
        });
        //console.log("between sent_at", sd, ed);
        console.log("messages length", state.filter_rest);
      }
      state.filter_rest.sort(function (a, b) {
        var dateA = new Date(a[column]),
          dateB = new Date(b[column]);
        return state.sorts[column].order ? dateB - dateA : dateA - dateB;
      });
    } else if (column === "waiting") {
      state.filter_rest = state.all_messages.filter((r) => {
        if (r.status === "To answer") return r;
      });
      if (
        state.sorts[column].between.end &&
        state.sorts[column].between.start
      ) {
        //console.log("between", column, state.sorts[column].between);
        const ed = new Date(state.sorts[column].between.end);
        const sd = new Date(state.sorts[column].between.start);
        if (ed < sd) return { error: true };
        state.filter_rest = state.filter_rest.filter((d) => {
          var time = new Date(d.sent_at);
          return sd <= time && time <= ed;
        });
      }
      state.filter_rest.sort(function (a, b) {
        var dateA = new Date(a.sent_at),
          dateB = new Date(b.sent_at);
        return state.sorts[column].order ? dateB - dateA : dateA - dateB;
      });
    }
    if (state.sorts.conversation.filter_by === "show_conversations")
      dispatch("filter_conversation", state.sorts.conversation.filter_by);
  },
  filter_bools({ state, rootState, dispatch }, column) {
    //console.log("bool->", column);
    if (column === "online") {
      state.filter_rest = state.all_messages.filter((d) => {
        if (
          state.sorts[column].order &&
          rootState.online_users.includes(d.guid)
        )
          return d;
        else if (
          !state.sorts[column].order &&
          !rootState.online_users.includes(d.guid)
        )
          return d;
      });
    } else if (column === "priority") {
      state.filter_rest = state.all_messages.filter((d) => {
        if (state.sorts[column].order && d.priority) return d;
        else if (!state.sorts[column].order && !d.priority) return d;
      });
    } else if (column === "add_to_cart") {
      state.filter_rest = state.all_messages.filter((d) => {
        const elem = rootState.productAdded.find(
          (element) => element.user_id == d.guid
        );
        if (state.sorts[column].order && elem) return d;
        else if (!state.sorts[column].order && !elem) return d;
      });
      // state.filter_rest.sort((a,b) => (a.add_to_cart.count < b.add_to_cart.count) ? 1 : ((b.add_to_cart.count < a.add_to_cart.count) ? -1 : 0))
    } else if (column === "purchase") {
      state.filter_rest = state.all_messages.filter((d) => {
        const elem = rootState.productPurchase.find(
          (element) => element.user_id == d.guid
        );
        if (state.sorts[column].order && elem) return d;
        else if (!state.sorts[column].order && !elem) return d;
      });
    }
    if (state.sorts.conversation.filter_by === "show_conversations")
      dispatch("filter_conversation", state.sorts.conversation.filter_by);
  },
  filter_status({ state, rootState, dispatch }, column) {
    if (
      column === "status" &&
      state.sorts[column] &&
      state.sorts[column].filter_by.length
    ) {
      //console.log(column, state.sorts[column].filter_by);
      state.filter_rest = state.all_messages.filter((d) => {
        if (state.sorts[column].filter_by.includes(d.statusObj.value)) return d;
      });
    } else if (
      column === "status_email" &&
      state.sorts[column] &&
      state.sorts[column].filter_by.length
    ) {
      state.filter_rest = state.all_messages.filter((d) => {
        if (state.sorts[column].filter_by.includes(d.EmailStatusObj.value))
          return d;
      });
    }
    //sort the fitch filter
    if (state.sorts.conversation.filter_by === "show_conversations")
      dispatch("filter_conversation", state.sorts.conversation.filter_by);
  },
  filter_conversation({ state, rootState, dispatch }, val) {
    //console.log(val);
    if (val === "show_all") {
      state.filter_rest = state.all_messages;
      if (state.sorts.selected_sort) {
        dispatch("filter_date", state.sorts.selected_sort);
        dispatch("filter_bools", state.sorts.selected_sort);
        dispatch("filter_status", state.sorts.selected_sort);
      }
    } else if (val === "show_conversations") {
      console.log(
        "state.sorts.conversation",
        state.sorts.conversation.data.data.length
      );
      state.filter_rest = state.filter_rest.filter((d) => {
        const index = state.sorts.conversation.data.data.findIndex(
          (x) => x.id === d.i_msg
        );
        if (index === -1) return d;
      });
    }
  },
  DELETE_MSG: ({}, params) => {
    //console.log("--> paras", params);
    return apiRequest()
      .post("message/delete_msg", params)
      .then(({ data }) => {
        //console.log(data);
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  CONVERSATION_LENGHT: ({}) => {
    return apiRequest()
      .get("message/conversations_less_lenght")
      .then(({ data }) => {
        state.sorts.conversation.data = data;
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  FETCH_MESSAGES: async (
    { commit, rootState, dispatch, state },
    { page, type }
  ) => {
    try {
      const context = await getContext(type, rootState.messangerItems);
      if (context === undefined) {
        throw "context not exits";
      }
      await dispatch("GET_TRACKING");
      if (
        rootState.ui.msgTrackingState.cart &&
        !state.add_to_cart_empty &&
        !rootState.productAdded.length
      ) {
        await dispatch("FETCH_PRODUCT_ADDED_TO_CART")
          .then((response) => {
            if (response.data.result) {
              state.add_to_cart_empty = true; //to make this call just ones
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (
        rootState.ui.msgTrackingState.purchase &&
        !state.purchase_emty &&
        !rootState.productPurchase.length
      ) {
        await dispatch("FETCH_PRODUCT_PURCHASE")
          .then((response) => {
            if (response.data.result) {
              state.purchase_emty = true; //to make this call just ones
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (page == 0) {
        state.all_messages = [];
        state.filter_rest = state.all_messages;
      }
      return apiRequest()
        .get(`users/adm_messages?page=${page}&context=${context}`)
        .then((response) => {
          const messages = response.data.data;
          const conversation_length =
            response.data.StoreConversationsLength.count;

          for (let i = 0; i < messages.length && i < conversation_length; i++) {
            const element = messages[i];
            waiting_calc(element);
            date_form(element);
            status_filter(element);
            last_message(element);
            Email_status_filter(element);
            SetAddToCart(element, rootState);
            SetPruchase(element, rootState);
            element.contact =
              element.firstname || element.email || `#${element.id}`;
          }
          console.log({
            length: messages.length,
            page,
            context,
          });
          const obj = {
            msg: messages,
            page: page,
            dispatch: dispatch,
            convearsation_length: response.data.StoreConversationsLength.count,
          };
          commit("SET_MSG", obj);
        });
    } catch (e) {
      console.log(e);
    }
  },
  FETCH_USER_MESSAGES: async ({ commit }, idUser) => {
    var messages = (await apiRequest().get(`users/adm_messages?id=${idUser}`))
      .data.data;

    if (window.localStorage.getItem("cleed_debug")) {
      console.log("---->>>>>>", messages);
    }

    messages.map((message) => {
      var m = message;
      try {
        if (typeof message.content !== "object") {
          m.content = JSON.parse(message.content);
        }
        return m;
      } catch (e) {
        //condition noted by adrien  (can you change "chat.not_here" to "Box_message_email")
        if (m.content === "chat.not_here") {
          m.content = "[Box Email & Message]";
        }
        return m;
      }
    });

    commit("SET_MESSAGES", messages);
    return messages;
  },
  UPDATE_MSG: ({}, params) => {
    return apiRequest()
      .post("message/update_conversation", params)
      .then(({ data }) => {
        // console.log(data);

        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  UPDATE_CHAT: ({}, params) => {
    console.log("--> paras", params);
    return apiRequest()
      .post("message/update_msg", params)
      .then(({ data }) => {
        //console.log(data);
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  SEND_TO_MAIL: ({ state }, { to, type, elements, lang, conversation_id }) => {
    return apiRequest()
      .post("message/EmailSendApi", {
        to,
        type,
        elements,
        lang,
        conversation_id,
      })
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        throw e.data?.message || e.message || e;
      });
  },
  CHANGE_CONVERSATION_SUBJECT: ({ state }, params) => {
    return apiRequest()
      .post("message/conversations_subjects", params)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  SEND_WHATSAPP_MESSAGE: async ({}, { guid, message }) => {
    return apiRequest()
      .post("whatsapp/chat", {
        guid: guid,
        message: message,
      })
      .then(({ data }) => {
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
  SEND_ATTACHMENTS: async ({}, { formData, guid }) => {
    console.log({ formData, guid });
    return apiRequest()
      .post(`attachments/admin/${guid}`, formData)
      .then(({ data }) => {
        console.log(data);
        return data;
      })
      .catch((e) => {
        throw e;
      });
  },
};

export default {
  state,
  actions,
  mutations,
};
